/**
 * @generated SignedSource<<252b1fdc1095d62aaf2f912c5e412103>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LoginEntryPoint = "CREATE_ACCOUNT_LOGIN" | "FREE_TRIAL_LOGIN" | "LOGIN" | "%future added value";
export type LoginInitiateInput = {
  clientMutationId?: string | null;
  login: LoginInitiate;
};
export type LoginInitiate = {
  email: string;
  entryPoint?: LoginEntryPoint | null;
  password: string;
};
export type EmailLoginInitiateMutation$variables = {
  input: LoginInitiateInput;
};
export type EmailLoginInitiateMutation$data = {
  readonly loginInitiate: {
    readonly errors: ReadonlyArray<{
      readonly messages: ReadonlyArray<string>;
      readonly path: string;
    }>;
    readonly redirectPath: string | null;
  };
};
export type EmailLoginInitiateMutation = {
  response: EmailLoginInitiateMutation$data;
  variables: EmailLoginInitiateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redirectPath",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messages",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailLoginInitiateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoginInitiatePayload",
        "kind": "LinkedField",
        "name": "loginInitiate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailLoginInitiateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoginInitiatePayload",
        "kind": "LinkedField",
        "name": "loginInitiate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76f69b6505bd3668a07f6f6942847cc1",
    "id": null,
    "metadata": {},
    "name": "EmailLoginInitiateMutation",
    "operationKind": "mutation",
    "text": "mutation EmailLoginInitiateMutation(\n  $input: LoginInitiateInput!\n) {\n  loginInitiate(input: $input) {\n    redirectPath\n    errors {\n      path\n      messages\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e57855a78e36d709d5479be6da1536ee";

export default node;
